<template>
  <div class="subpage-dashboards subpage-report--dashboard subpage-dashboards--left-spacer">
    <!-- Yearly Totals -->
    <section v-if="billingStats" class="my-account__full-width-section gds-space-stack-xl">
      <h2 id="yearly-totals" class="gds-display-1 gds-space-stack-l">Yearly Totals</h2>
      <div class="my-account-billing-report__row gds-flex-container gds-flex-container--left">
        <div class="my-account-billing-report__col3">
          <div class="my-account-billing-report__data-label" id="current-year-bills">{{billingStats.thisYear.year}} Bills</div>
          <div class="my-account-billing-report__large-data" aria-labelledby="yearly-totals current-year-bills">{{billingStats.thisYear.billTotal | currency(true)}}</div>
        </div>
        <div class="my-account-billing-report__col3">
          <div class="my-account-billing-report__data-label" id="current-year-payments">{{billingStats.thisYear.year}} Payments</div>
          <div class="my-account-billing-report__large-data" aria-labelledby="yearly-totals current-year-payments">{{billingStats.thisYear.paymentTotal | currency(true)}}</div>
        </div>
        <div class="my-account-billing-report__col3">
          <div class="my-account-billing-report__data-label" id="previous-year-bills">{{billingStats.lastYear.year}} Bills</div>
          <div class="my-account-billing-report__large-data" aria-labelledby="yearly-totals previous-year-bills">{{billingStats.lastYear.billTotal | currency(true)}}</div>
        </div>
        <div class="my-account-billing-report__col3">
          <div class="my-account-billing-report__data-label" id="previous-year-payments">{{billingStats.lastYear.year}} Payments</div>
          <div class="my-account-billing-report__large-data" aria-labelledby="yearly-totals previous-year-payments">{{billingStats.lastYear.paymentTotal | currency(true)}}</div>
        </div>
      </div>
    </section>
    <!-- Seasonal Averages -->
    <section v-if="billingStats" class="my-account__full-width-section gds-space-stack-xl">
      <h2 id="seasonal-averages" class="gds-display-1 gds-space-stack-l">Seasonal Averages</h2>
      <div class="my-account-billing-report__row gds-flex-container gds-flex-container--left">
        <div class="my-account-billing-report__col3">
          <div class="my-account-billing-report__data-label" id="winter-avg">
            Winter
            <span class="gds-font-book">(Dec, Jan, Feb)</span>
          </div>
          <div class="my-account-billing-report__large-data" aria-labelledby="seasonal-averages winter-avg">{{billingStats.winterAverage | currency(true)}}</div>
        </div>
        <div class="my-account-billing-report__col3">
          <div class="my-account-billing-report__data-label" id="spring-avg">
            Spring
            <span class="gds-font-book">(Mar, Apr, May)</span>
          </div>
          <div class="my-account-billing-report__large-data" aria-labelledby="seasonal-averages spring-avg">{{billingStats.springAverage | currency(true)}}</div>
        </div>
        <div class="my-account-billing-report__col3">
          <div class="my-account-billing-report__data-label" id="summer-avg">
            Summer
            <span class="gds-font-book">(Jun, July, Aug)</span>
          </div>
          <div class="my-account-billing-report__large-data" aria-labelledby="seasonal-averages summer-avg">{{billingStats.summerAverage | currency(true)}}</div>
        </div>
        <div class="my-account-billing-report__col3">
          <div class="my-account-billing-report__data-label" id="fall-avg">
            Fall
            <span class="gds-font-book">(Sept, Oct, Nov)</span>
          </div>
          <div class="my-account-billing-report__large-data" aria-labelledby="seasonal-averages fall-avg">{{billingStats.fallAverage | currency(true)}}</div>
        </div>
      </div>
    </section>

    <!-- Billing Report -->
    <section class="my-account__full-width-section gds-space-stack-xl">
      <h2 class="gds-display-1 gds-space-stack-l">Detailed Report</h2>
      <div class="my-account-billing-report__data-tables-wrapper">
        <p>View and customize a spreadsheet of all bill charges, quantities, and rates for the dates you choose. The detailed report will open in a new window.</p>
        <a
          :href="EnvironmentConstants.BillReportURL + '/?accountNumber=' + currentAccount.accountNumber"
          target="_blank"
          class="gds-button gds-round gds-space-stack-l"
        >Launch Detailed Report</a>
      </div>
    </section>
  </div>
</template>

<script>
import { EnvironmentConstants } from "../../../environment";
import { GetFormattedBillingInfo } from '../../../services/billing';

export default {
  name: "SubpageReport",
  components: {
  },
  data() {
    return {
      EnvironmentConstants,
      billingStats: undefined,
    };
  },
  computed: {
    currentAccount() {
      return this.$store.state.user.currentAccount;
    },
  },
  async mounted() {
    this.RefreshData();
  },
  methods: {
    async RefreshData() {
      this.billingStats = undefined;
      const calculated = await GetFormattedBillingInfo(this.currentAccount.accountNumber);
      this.billingStats = calculated;
    },
  },
  watch: {
    async currentAccount() {
      await this.RefreshData();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>